import { useParams } from 'react-router-dom';
import * as Lucide from 'lucide-react';
import CTA from '../components/CTA';
import { DetailGallery } from '../components/gallery/DetailGallery';
import { DetailBreadcrumb, DetailNavigation } from '../components/details/DetailNavigation';
import { ProductInfo } from '../components/details/ProductInfo';
import { RelatedProjects } from '../components/details/RelatedProjects';
import { getRelatedProjects } from '../lib/portfolio';
import { usePortfolioDetail } from '../hooks/usePortfolioDetail';
import { useSeo } from '../hooks/useSeo';

export default function ProductDetailPage() {
  const { slug } = useParams();
  const { item: product, images, ...navigation } = usePortfolioDetail('product', slug);
  useSeo({
    title: product?.title || 'Urun', description: product?.description,
    path: product ? `/urunler/${product.slug}` : '/urunler', image: product?.image,
  });
  if (!product) return null;
  const related = getRelatedProjects(product);
  const Icon = Lucide[product.icon] || Lucide.Box;
  return (
    <main>
      <DetailBreadcrumb kind="product" basePath="/urunler" label="Tum Urunler" />
      <section className="py-16 lg:py-20 px-6 lg:px-10">
        <div className="max-w-[1300px] mx-auto grid lg:grid-cols-2 gap-10 lg:gap-14">
          <DetailGallery key={product.slug} kind="product" title={product.title} images={images} icon={Icon} />
          <ProductInfo product={product} hasRelated={related.length > 0} />
        </div>
      </section>
      <RelatedProjects projects={related} />
      <DetailNavigation kind="product" label="Urun" {...navigation} />
      <CTA />
    </main>
  );
}